var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "row" },
    [
      _c(
        "div",
        { staticClass: "col-12" },
        [
          _c(
            "c-table",
            {
              ref: "table",
              attrs: {
                title: "사용자별 패널티 목록",
                isTitle: true,
                columns: _vm.grid.columns,
                merge: _vm.grid.merge,
                gridHeight: _vm.gridHeight,
                data: _vm.tabParam.ctoPenaltyModels,
                filtering: false,
                gridHeightAuto: true,
                isExcelDown: false,
                columnSetting: false,
                usePaging: false,
                noDataLabel: "사용자별 패널티를 추가하세요.",
                hideBottom: true,
                editable: _vm.editable && !_vm.disabled,
                rowKey: "userPenaltyId",
                selection: "multiple",
              },
              scopedSlots: _vm._u([
                {
                  key: "customArea",
                  fn: function ({ props, col }) {
                    return [
                      col.name === "userName"
                        ? [
                            _vm._v(" " + _vm._s(props.row.userName) + " "),
                            _c("span", [
                              _vm.editable && !_vm.disabled
                                ? _c(
                                    "div",
                                    [
                                      _c(
                                        "q-btn-group",
                                        {
                                          staticClass: "ColumInnerBtnGroup",
                                          attrs: { outline: "" },
                                        },
                                        [
                                          _vm._l(col.btns, function (btn, idx) {
                                            return [
                                              _c(
                                                "q-btn",
                                                {
                                                  key: idx,
                                                  staticClass: "ColumInnerBtn",
                                                  attrs: {
                                                    label: btn.label,
                                                    icon: btn.icon
                                                      ? btn.icon
                                                      : void 0,
                                                    color: btn.color
                                                      ? btn.color
                                                      : "blue-grey-4",
                                                    "text-color": btn.textColor
                                                      ? btn.textColor
                                                      : "white",
                                                    align: "center",
                                                  },
                                                  on: {
                                                    click: function ($event) {
                                                      $event.stopPropagation()
                                                      return _vm.innerBtnClicked(
                                                        col,
                                                        props,
                                                        btn
                                                      )
                                                    },
                                                  },
                                                },
                                                [
                                                  btn.tooltip
                                                    ? _c("q-tooltip", [
                                                        _c("span", {
                                                          domProps: {
                                                            innerHTML: _vm._s(
                                                              btn.tooltip
                                                            ),
                                                          },
                                                        }),
                                                      ])
                                                    : _vm._e(),
                                                ],
                                                1
                                              ),
                                            ]
                                          }),
                                        ],
                                        2
                                      ),
                                    ],
                                    1
                                  )
                                : _vm._e(),
                            ]),
                          ]
                        : _vm._e(),
                    ]
                  },
                },
              ]),
            },
            [_c("template", { slot: "table-button" })],
            2
          ),
        ],
        1
      ),
      _c("div", { staticClass: "popup-bottom-bar" }, [
        _c(
          "div",
          { staticClass: "popup-bottom-bar-btngroup" },
          [
            _c(
              "q-btn-group",
              { attrs: { outline: "" } },
              [
                _vm.editable && !_vm.disabled
                  ? _c("c-btn", {
                      attrs: { flat: true, label: "추가", icon: "add" },
                      on: { btnClicked: _vm.addPenalty },
                    })
                  : _vm._e(),
                _vm.editable &&
                !_vm.disabled &&
                _vm.tabParam.ctoPenaltyModels.length > 0
                  ? _c("c-btn", {
                      attrs: { flat: true, label: "삭제", icon: "remove" },
                      on: { btnClicked: _vm.removePenalty },
                    })
                  : _vm._e(),
                _vm.editable &&
                !_vm.disabled &&
                _vm.tabParam.ctoPenaltyModels.length > 0
                  ? _c("c-btn", {
                      attrs: {
                        flat: true,
                        url: _vm.saveUrl,
                        isSubmit: _vm.isSave,
                        param: _vm.tabParam.ctoPenaltyModels,
                        mappingType: "POST",
                        label: "저장",
                        icon: "save",
                      },
                      on: {
                        beforeAction: _vm.savePenalty,
                        btnCallback: _vm.saveCallback,
                      },
                    })
                  : _vm._e(),
              ],
              1
            ),
          ],
          1
        ),
        _c(
          "div",
          { staticClass: "popup-bottom-bar-close" },
          [
            _c("q-btn", {
              attrs: { flat: "", color: "gray", icon: "arrow_back" },
              on: { click: _vm.closePopUps },
            }),
          ],
          1
        ),
      ]),
      _c("c-dialog", { attrs: { param: _vm.popupOptions } }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }